import { render, staticRenderFns } from "./IpAddress.vue?vue&type=template&id=6404bd2b&"
import script from "./IpAddress.vue?vue&type=script&lang=js&"
export * from "./IpAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports